import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

import "../../styles/buttons.css";
import { faEdit, faTrashAlt } from "@fortawesome/free-regular-svg-icons";

export const AddButton = ({ caption, link,state }) => {

    const  navigate  = useNavigate();

    const handleAddClick = () => {
        navigate(link,{state});
    }

    return (
        <div className="center-box">
            <button 
                className={classNames("right", "cap", "add-notes")}
                onClick={handleAddClick}
            >
                <FontAwesomeIcon icon={faPlusCircle}  className="plus-icon"/>
                <span className="right_txt">{caption}</span>
            </button>
        
        </div>
    )
}

export const UpdateButtons = ({caption, link, state}) => {

    const  navigate  = useNavigate();

    const handleAddClick = () => {
        navigate(link,{state});
    }

    return (
        <div className="center-box">
            <button 
                className={classNames("right", "cap", "add-notes")}
                onClick={handleAddClick}
            >
                <FontAwesomeIcon icon={faEdit}  className="plus-icon"/>
                <span className="right_txt">{caption}</span>
            </button>
        
        </div>
    )
}

export const DeleteButton = ({caption, link, state}) => {

    const  navigate  = useNavigate();

    const handleAddClick = () => {
        navigate(link,{state});
    }

    return (
        <div className="center-box">
            <button 
                className={classNames("right", "cap", "add-notes")}
                onClick={handleAddClick}
            >
                <FontAwesomeIcon icon={faTrashAlt}  className="plus-icon"/>
                <span className="right_txt">{caption}</span>
            </button>
        
        </div>
    )
}